import React from 'react';
import { Select, Box } from 'localmed-core';

import OfficeSelectMarker from './OfficeSelectMarker';

export default function OfficeSelect({ offices, activeOfficeId, setActiveOfficeId }) {
  const items = offices
    ? offices.map((office, idx) => ({
        ...office,
        display: office.address1,
        Component: (
          <OfficeSelectMarker office={office} index={idx} active={office.id === activeOfficeId} />
        ),
      }))
    : [];
  const singleOffice = offices.length === 1 ? offices[0] : null;

  return (
    <Box>
      {singleOffice ? (
        <OfficeSelectMarker office={singleOffice} index={0} active />
      ) : (
        <Select
          gray
          selectedItem={items.find((item) => item.id === activeOfficeId)}
          items={items}
          disableSearch
          onChange={(item) => {
            if (item) setActiveOfficeId(item.id);
          }}
          renderSelected={({ selectedItem }) => selectedItem.Component}
          renderOption={({ item }) => item.Component}
        />
      )}
    </Box>
  );
}
